/**
 * Rewrites a server-built file name into one path segment.
 *
 * File storage keeps each file in a uuid directory and accepts only a single
 * segment: no `/`, `\`, NUL, or `..`. A report stem or a document number can
 * contain those characters (`RA/2026/1`). Each of them is replaced with `-`
 * so the name can be stored beside that uuid.
 *
 * A lone `.` is kept, so an extension such as `.pdf` stays. An empty name
 * stays empty.
 *
 * @param name - Server-built file name, including any extension
 * @returns The same name with separators, NUL bytes, and `..` replaced by `-`
 *
 * @example
 * toSafeFileName('RA/2026/1.pdf'); // 'RA-2026-1.pdf'
 * toSafeFileName('a\\b'); // 'a-b'
 * toSafeFileName('a..b'); // 'a-b'
 */
export function toSafeFileName(name: string): string {
  return name.replace(/[\\/\0]/g, '-').replace(/\.\./g, '-');
}
